import React, { useState, useEffect, useContext, useReducer, useRef } from 'react';
import { Link } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
    Container, createMuiTheme, Toolbar, Typography, CssBaseline, IconButton,
    TextField, Snackbar, FormControl, InputLabel, Select, Divider, Fab, Grid, AppBar
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { LoadRecoveryEVSDetails } from "../../offline/dataService/recoveryEVSOfflineData";
import { GlobalTheme } from '../../layouts/theme';
import { Context } from "../contexts/siteContext";
import { Theme } from '../contexts/themeContext';
import { AssignedToUsers } from '../contexts/assignedToUsers.js';
import { TransactionTime } from '../common/transactionTime';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import VisitationEVSAdd from './visitationEVSAdd';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '5px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function VisitaionEVSList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const visitaionRef = useRef();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const [selectedDate, setSelectedDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [visitDate, setVisitDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite));
    const [selectedLocation, setSelectedLocation] = useState(props.siteLocation ? props.siteLocation : []);
    const [locations, setLocations] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [open, setOpen] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [action, setAction] = useState('');
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const tableHeight = window.innerHeight - 350;
    const [appVisitationTypes, setAppVisitationTypes] = useReducer((state, newState) => ({ ...state, ...newState }),
        {
            roundTypes: [],
            roundOns: [],
            yesNo: [],
            reasons: [],
            ratings: [],
            followUps: [],
            issueTypes: [],
            priorityTypes: []
        });
    const [appVisitations, setAppVisitations] = useState(
        {
            AppVisitationId: 0,
            RoundType: 0,
            RoundOn: 0,
            VisitDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            GeoLocation: 0,
            SiteId: defaultSite.id,
            PatientName: ''
        });
    const [visitations, setVisitations] = useState({
        columns: [
            { field: 'VisitDateString', title: 'Visit Date', width: '10%' },
            { field: 'GeoLocationName', title: 'Location', width: '50%', render: rowData => getShortName((rowData.GeoLocationName)) },
            { field: 'RoundTypeName', title: 'Round Type', width: '10%' },
            { field: 'RoundOnName', title: 'Round On', width: '15%' },
            { field: 'Rounder', title: 'Rounder', width: '10%' }
        ],
        data: []
    });

    const triggerSave = () => {
        visitaionRef.current.save();
    };

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const getShortName = (name) => {
        if (name.indexOf("\\") === -1)
            return name;
        else
            return ".." + name.substring(name.indexOf("\\"));
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
        setSelectedLocation([]);
    };

    const openAddVisitation = () => {
        setOpen(true);
        setAction('Add');
        setRecordToBeEdit([]);
        setVisitDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite));
    };

    const closeAddVisitation = () => {
        TransactionTime.cancel();
        setOpen(false);
        setRecordToBeEdit([]);
        setSelectedLocation([]);
        reset();
        setAction('');
        setSelectedDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
        setModified(false);
    };

    const reset = () => {
        setAppVisitations({
            ...appVisitations,
            AppVisitationId: 0,
            RoundType: 0,
            RoundOn: 0,
            VisitDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            GeoLocation: 0,
            SiteId: defaultSite.id,
            PatientName: ''
        });
    };

    const updateList = (item, goToRecovery) => {
        if (item !== null) {
            const data = visitations.data;
            var location = locations.filter(l => l.id === item.GeoLocation);
            item.GeoLocationName = location[0].name;
            let index = appVisitationTypes.roundTypes.findIndex(type => type.AppVisitationTypeId === item.RoundType);
            item.RoundTypeName = appVisitationTypes.roundTypes[index].Title;
            index = appVisitationTypes.roundOns.findIndex(type => type.AppVisitationTypeId === item.RoundOn);
            item.RoundOnName = appVisitationTypes.roundOns[index].Title;
            index = data.findIndex(d => d.AppVisitationId === item.AppVisitationId);
            if (index === -1)
                data.push(item);
            else
                data[index] = item;
            setVisitations({ ...visitations, data: data });
        }
        if (goToRecovery) {
            props.history.push({ pathname: '/RecoveryEVSList', appVisitationTypes: appVisitationTypes, location: location, data: item });
        }
        else {
            closeAddVisitation();
            setSuccessMessage("Visitation EVS is saved Successfully.");
            setOpenSuccess(true);
        }
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        setAppVisitations({ ...appVisitations, VisitDate: date });
        setSelectedDate(date);
    };

    const visitDateChanged = date => {
        setVisitDate(moment(date).format("MM/DD/YYYY hh:mm a"));
        visitaionRef.current.valueChanged();
        setModified(true);
    };

    const locationChanged = (e) => {
        setSelectedLocation(e);
        if (e.length > 0) {
            setAppVisitations({ ...appVisitations, GeoLocation: e[0]?.id });
        }
        else {
            setAppVisitations({ ...appVisitations, GeoLocation: 0 });
        }

        if (action === "Add" || action === "Edit") {
            visitaionRef.current.valueChanged();
            setModified(true);
        }
    };

    const roundTypeChanged = (event) => {
        setAppVisitations({ ...appVisitations, RoundType: parseInt(event.target.value) });
        if (action === "Add" || action === "Edit") {
            visitaionRef.current.valueChanged();
            setModified(true);
        }
    };

    const roundOnChanged = (event) => {
        setAppVisitations({ ...appVisitations, RoundOn: parseInt(event.target.value) });
        if (action === "Add" || action === "Edit") {
            visitaionRef.current.valueChanged();
            setModified(true);
        }
    };

    const patientNameChanged = (event) => {
        setAppVisitations({ ...appVisitations, PatientName: event.target.value })
        if (action === "Add" || action === "Edit") {
            visitaionRef.current.valueChanged();
            setModified(true);
        }
    };
    
    const editVisitation = (event, rowData) => {
        setRecordToBeEdit(rowData);
        setOpen(true);
        setAction('Edit');
        setAppVisitations({
            ...appVisitations,
            GeoLocation: rowData.GeoLocation,
            RoundOn: rowData.RoundOn,
            RoundType: rowData.RoundType,
            PatientName: rowData.PatientName
        });
        setVisitDate(rowData.VisitDate);
        var location = locations.filter(x => x.id === rowData.GeoLocation);
        setSelectedLocation(location);
    };

    const getLocations = () => {
        setBackDrop(true);
        HttpService.post('/VisitationLog/GetGeoLocationBranchVisits', {
            Date: selectedDate,
            Key: "GetAll",
            MaxId: -1,
            Site: defaultSite.id,
            GetAll: true
        })
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GeoLocationBranchVisits");
                result.data = offlineResult.OfflineData.data;
            }
            else {
                offlineService.removeOfflineBySite(defaultSite.id, "GeoLocationBranchVisits");
                offlineService.addOffline(defaultSite.id, "GeoLocationBranchVisits", result);
            }
            setLocations(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationTypes = () => {
        setBackDrop(true);
        HttpService.post('/VisitationEVS/GetAppVisitationTypes')
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationTypes");
                result.data = offlineResult.OfflineData.data;
            }
            else {
                offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationTypes");
                offlineService.addOffline(defaultSite.id, "AppVisitationTypes", result);
            }

            var allTypes = result.data;
            setAppVisitationTypes({ roundTypes: allTypes.filter(x => x.SubType === "RoundType") });
            setAppVisitationTypes({ roundOns: allTypes.filter(x => x.SubType === "RoundOn") });
            setAppVisitationTypes({ yesNo: allTypes.filter(x => x.SubType === "YesNo") });
            setAppVisitationTypes({ reasons: allTypes.filter(x => x.SubType === "Reason") });
            setAppVisitationTypes({ ratings: allTypes.filter(x => x.SubType === "Rating") });
            setAppVisitationTypes({ followUps: allTypes.filter(x => x.SubType === "FollowUpType") });
            setAppVisitationTypes({ issueTypes: allTypes.filter(x => x.SubType === "IssueType") });
            setAppVisitationTypes({ priorityTypes: allTypes.filter(x => x.SubType === "Priority") });
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationTemplates = () => {
        HttpService.post('/VisitationEVS/GetAppVisitationTemplates')
        .then((result) => {
            if (result && !result.offline) {
                offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationTemplates");
                offlineService.addOffline(defaultSite.id, "AppVisitationTemplates", result);
            }
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitations = () => {
        var model = appVisitations;
        setBackDrop(true);
        HttpService.post('/VisitationEVS/GetAppVisitations', model)
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitations");
                result.data = offlineResult.OfflineData.data;
            }
            else if (model.AppVisitationId === 0 && model.GeoLocation === 0 && model.RoundType === 0 && model.RoundOn === 0 && model.VisitDate === ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite)) {
                offlineService.removeOfflineBySite(defaultSite.id, "AppVisitations");
                offlineService.addOffline(defaultSite.id, "AppVisitations", result);
            }
            setVisitations({ ...visitations, data: result.data });
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationAnswers = () => {
        HttpService.post('/VisitationEVS/GetAppVisitationAnswers', { AppVisitation: 0 })
        .then((result) => {
            if (result && !result.offline) {
                offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationAnswers");
                offlineService.addOffline(defaultSite.id, "AppVisitationAnswers", result.data);
            }
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getLocations();
        getAppVisitationTypes();
        getAppVisitationTemplates();
        getAppVisitationAnswers();
        LoadRecoveryEVSDetails(defaultSite, ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite));
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (action === "")
            getAppVisitations();
        // eslint-disable-next-line 
    }, [selectedDate, appVisitations.GeoLocation, appVisitations.RoundOn, appVisitations.RoundType, appVisitations.VisitDate]);

    useEffect(() => {
        if (assignedUsers.length === 0 || assignedUsers[0].uniBrief !== defaultSite.houseCode.toString()) {
            getAssignedToUsers();
        }
        // eslint-disable-next-line 
    }, []);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="visitationBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            {!open && <Link to="/"><KeyboardBackspaceIcon /></Link>}
                            {open &&
                                <IconButton edge="start" color="inherit" onClick={triggerSave} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                            }
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>&nbsp;{action} Visitation EVS</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                {!open && <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={openAddVisitation}>
                                    <AddIcon />
                                </Fab>
                                }
                                {open && <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={closeAddVisitation}>
                                    <CloseIcon />
                                </Fab>
                                }
                                <SmallMenu moduleName={"VisitationEVS"} modified={modified} saveCallback={triggerSave} />
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off">
                                {(action === "") &&
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker disableToolbar autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            id="VisitDate"
                                            label="Visit Date"
                                            format="MM/dd/yyyy"
                                            size="small"
                                            disableFuture="true"
                                            value={selectedDate}
                                            onChange={date => dateChanged(date)}
                                            InputAdornmentProps={{ position: "start" }}
                                            //PopoverProps={{ style: { ...{ left: '-400px' } } }}
                                            PopoverProps={{
                                                anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                transformOrigin: { horizontal: "left", vertical: "top" }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                }
                                {(action !== "") &&
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDateTimePicker hideTabs autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            id="VisitDateTime"
                                            label="Visit Date"
                                            format="MM/dd/yyyy hh:mm a"
                                            size="small"
                                            disableFuture="true"
                                            value={visitDate}
                                            onChange={date => visitDateChanged(date)}
                                            disabled={action === "Edit"}
                                            InputAdornmentProps={{ position: "start" }}
                                            PopoverProps={{
                                                anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                transformOrigin: { horizontal: "left", vertical: "top" }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                }
                                <Typeahead
                                    style={{ color: (action === "Edit" ? "black" : "") }}
                                    id="LocationList"
                                    labelKey="name"
                                    placeholder="Choose a Location..."
                                    onChange={(e) => locationChanged(e)}
                                    options={locations}
                                    selected={selectedLocation}
                                    disabled={action === "Edit"}
                                    renderMenuItemChildren={(option, key) => (
                                        <>
                                            <div className="dropdown-widget">
                                                <div className="left">{getShortName(option.name)}</div>
                                            </div>
                                        </>
                                    )}
                                />
                                <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                    <InputLabel htmlFor="RoundType">Round Type</InputLabel>
                                    <Select
                                        native
                                        label="Round Type"
                                        size="small"
                                        value={appVisitations.RoundType}
                                        onChange={(e) => { roundTypeChanged(e) }}
                                    >
                                        <option aria-label="None" key="0" value="0" />
                                        {
                                            appVisitationTypes.roundTypes.map((option, key) => {
                                                return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                    <InputLabel htmlFor="RoundOn">Round On</InputLabel>
                                    <Select
                                        native
                                        label="Round On"
                                        size="small"
                                        value={appVisitations.RoundOn}
                                        onChange={(e) => { roundOnChanged(e) }}
                                    >
                                        <option aria-label="None" key="0" value="0" />
                                        {
                                            appVisitationTypes.roundOns.map((option, key) => {
                                                return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                {open && <TextField size="small" fullWidth
                                    id="PatientName"
                                    label="Patient Name"
                                    variant="outlined"
                                    value={appVisitations.PatientName}
                                    onChange={(e) => { patientNameChanged(e) }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                }
                            </div>
                            <Divider style={{ height: '1px', backgroundColor: currentTheme.secondary, marginTop: '5px', marginBottom: '10px' }} />
                            <div style={{ maxWidth: '100%' }}>
                                {!open &&
                                    <MaterialTable
                                        title=""
                                        columns={visitations.columns}
                                        data={visitations.data}
                                        onRowClick={(event, rowData) => { editVisitation(event, rowData); }}
                                        components={{
                                            Toolbar: (props) => (
                                                <div
                                                    style={{
                                                        height: "0px",
                                                    }}
                                                >
                                                    <MTableToolbar {...props} />
                                                </div>
                                            )
                                        }}
                                        style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                        options={{
                                            filtering: false,
                                            search: false,
                                            paging: false,
                                            actionsColumnIndex: -1,
                                            minBodyHeight: tableHeight,
                                            maxBodyHeight: tableHeight,
                                            headerStyle: {
                                                fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                            },
                                            actionsCellStyle: {
                                                color: currentTheme.secondary,
                                                hover: 'white'
                                            },
                                            rowStyle: rowStyle
                                        }}
                                        actions={[
                                            {
                                                icon: EditIcon,
                                                tooltip: 'Edit Visitation EVS',
                                                onClick: (event, rowData) => { editVisitation(event, rowData); }
                                            }
                                        ]}
                                    />
                                }

                                {open && <VisitationEVSAdd ref={visitaionRef}
                                    key={appVisitations.AppVisitationId}
                                    parentCallback={closeAddVisitation}
                                    refreshGrid={updateList}
                                    patientName={appVisitations.PatientName}
                                    roundType={appVisitations.RoundType}
                                    roundOn={appVisitations.RoundOn}
                                    location={selectedLocation}
                                    visitDate={visitDate}
                                    appVisitation={recordToBeEdit}
                                    appVisitationTypes={appVisitationTypes}
                                    theme={currentTheme}
                                    model={recordToBeEdit}
                                />
                                }
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
